import React, { FC } from 'react'
import { Container } from '@ucheba/ui/components/Container/desktop'
import styled from 'styled-components'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { ETypeRequest, IIndexEgePageProps } from '../types'
import SC from '../base/IndexEgePageTips.styles'
import bgImageTopRight from '../assets/img__tips_cube_top-right_desktop.png'
import bgImageTopLeft from '../assets/img__tips_cube_top-left.png'
import { EApplicationFunnels } from '../../../../../components/AppliactionForm/types'
import TipsBlock from '../../../../../components/Blocks/TipsBlock/desktop'
import { useSelectProductRequestApplication } from '../../../../../components/SelectProductRequestApplication/bll'

const { Block, TopRightImage: TopRightImageSC, AbsoluteImage } = SC

const TopRightImage = styled(TopRightImageSC)`
  top: -54px;
  right: 0;
  height: 294px;
`

const TopLeftImage = styled(AbsoluteImage)`
  top: 0;
  left: 0;
  width: 160px;
  height: 160px;
`

const IndexEgePageTips: FC<IIndexEgePageProps['content']['tips']> = (props) => {
  const { title, list } = props
  const { selectGroup } = useSelectProductRequestApplication({})

  return (
    <Block id='questions'>
      <Container>
        <Grid justifyContent='center'>
          <GridCol uxs={24} lg={18}>
            <TipsBlock
              title={title}
              list={list}
              handleClickRequest={() => {
                selectGroup(
                  EApplicationFunnels.course_booking,
                  ETypeRequest.ege_lead_request
                )
              }}
            />
          </GridCol>
        </Grid>
      </Container>

      <TopLeftImage src={bgImageTopLeft} />
      <TopRightImage src={bgImageTopRight} />
    </Block>
  )
}

export default IndexEgePageTips
